import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { API_BASE_URL } from '@gisgo/shared';

export interface ApiMeUser {
  readonly id: number;
  readonly name: string;
  readonly phone: string | null;
  readonly email: string | null;
  readonly roles: readonly string[];
}

/** Client auth Sanctum (mêmes endpoints que pwa-restaurant). */
@Injectable({ providedIn: 'root' })
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  login(email: string, password: string): Observable<string> {
    return this.http
      .post<{ token: string }>(`${this.baseUrl}/auth/login`, { email, password })
      .pipe(map((response) => response.token));
  }

  me(): Observable<ApiMeUser> {
    return this.http
      .get<{ user: ApiMeUser }>(`${this.baseUrl}/auth/me`)
      .pipe(map((response) => response.user));
  }
}
